import InterceptedByPositionPref from "./intercepted-by-position-pref";

export default class BrokenUpByPositionPref extends InterceptedByPositionPref {
    constructor(play, fragment) {
        super(play, fragment);
    }
}
